module.exports = __webpack_public_path__ + "a74079dde65aaa5ca546e7f6ece8dd.png";